<template lang="html">
  <div>
    <b-navbar variant="faded" type="light" toggleable="md">
      <b-navbar-brand>
        <router-link to="/">
          <HappyGLogo/>
        </router-link>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse">
        <span class="navbar-toggler-icon">
                <MenuToggleImage />
        </span>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto pr-5">
          <b-nav-item><router-link to="/">Home</router-link></b-nav-item>
          <b-nav-item><router-link to="/about">About Us</router-link></b-nav-item>
          <b-nav-item><a href="mailto:connect@happyg.care">Contact</a></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import HappyGLogo from '../svg/HappyGLogo'
import MenuToggleImage from '../svg/MenuToggleImg'

export default {
  components: {
    HappyGLogo,
    MenuToggleImage,
  },
}
</script>

<style lang="css" scoped>
  .navbar {
    padding: 1em;
    background: var(--white);
  }
  .navbar-brand {
    width: 40px;
    height: auto;
  }
  .navbar-nav {
    align-self: end;
  }
  .navbar-light .navbar-toggler {
    color: #3a62cc;
    border: none;
  }
  .navbar-light .navbar-toggler-icon {
    background: transparent;
  }
  @media (min-width: 768px) {
    .navbar {
      padding: 1em 5em;
      background: transparent;
    }
  }
</style>
